import React from 'react';
import { Space, Button, Popconfirm, Typography } from 'antd';
import { CalculatorOutlined, PlusOutlined } from '@ant-design/icons';
import { StrategyPhase } from '../ProfitScenario/types';
import { calculatePhaseMetrics } from '../ProfitScenario/calculations';

const { Text } = Typography;

interface StrategyHeaderProps {
    phases: StrategyPhase[];
    landedCost: number;
    fbaFee: number;
    referralRate: number;
    storageFee: number;
    generateFullPlan: () => void;
    addPhase: () => void;
}

export const StrategyHeader: React.FC<StrategyHeaderProps> = ({
    phases,
    landedCost,
    fbaFee,
    referralRate,
    storageFee,
    generateFullPlan,
    addPhase
}) => {
    // 计算总汇总
    const totalMetrics = phases.reduce((acc, phase) => {
        const metrics = calculatePhaseMetrics(phase, landedCost, fbaFee, referralRate, storageFee);
        return {
            totalSales: acc.totalSales + metrics.totalSales,
            totalNetProfit: acc.totalNetProfit + metrics.totalNetProfit,
            totalUnits: acc.totalUnits + metrics.totalUnits,
            totalAdCost: acc.totalAdCost + metrics.totalAdCost
        };
    }, { totalSales: 0, totalNetProfit: 0, totalUnits: 0, totalAdCost: 0 });

    const totalNetMargin = totalMetrics.totalSales > 0
        ? (totalMetrics.totalNetProfit / totalMetrics.totalSales) * 100
        : 0;

    const totalTacos = totalMetrics.totalSales > 0
        ? (totalMetrics.totalAdCost / totalMetrics.totalSales) * 100
        : 0;

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <Space><CalculatorOutlined /> <span style={{ fontSize: 16, fontWeight: 500 }}>90天运营策略模拟</span></Space>
            <Space>
                <div style={{ marginRight: 16, fontSize: 15 }}>
                    总销售额: <Text strong>${totalMetrics.totalSales.toFixed(0)}</Text> |
                    总净利: <Text type={totalMetrics.totalNetProfit >= 0 ? 'success' : 'danger'} strong>${totalMetrics.totalNetProfit.toFixed(0)}</Text> ({totalNetMargin.toFixed(1)}%) |
                    总TACOS: {totalTacos.toFixed(1)}%
                </div>
                <Popconfirm
                    title="生成完整计划将覆盖当前数据"
                    description="确定要生成包含新品推广期、排名增长期、稳定盈利期的完整90天计划吗？"
                    onConfirm={generateFullPlan}
                >
                    <Button icon={<CalculatorOutlined />}>
                        一键生成计划
                    </Button>
                </Popconfirm>
                <Button type="primary" icon={<PlusOutlined />} onClick={addPhase} disabled={phases.length >= 5}>
                    添加阶段
                </Button>
            </Space>
        </div>
    );
};
